import React from 'react';
import { documentLinkPropTypes } from './propTypes';
import './styles.scss';

const DocumentLink = ({ link = "#", text, target = "_blank", icon = null, onClick = null, disabled = false, className = ""}) => {

      return (
          <li className={`document-link ${disabled ? "disabled" : ""} ${className}`}>
              { icon }
              { disabled ? <span>{ text }</span> : <a href={ link } target={ target } onClick={onClick}>{ text }</a> }
          </li>
      );
};

DocumentLink.propTypes = documentLinkPropTypes;

export default DocumentLink;